import React, { FC } from 'react';
import { Link } from 'react-router-dom';

type PathSection = { value: string, displayName: string, disableClick?: boolean };

type Props = {
    path: PathSection[];
    onClick: (item: PathSection) => void;
    className?: string;
};

const Breadcrumb: FC<Props> = ({ path, onClick, className = '' }) => {
    return (
        <div className={`flex flex-row pb-4  text-base font-sans ${className}`}>
            {path.map((item: PathSection, i: number) => (
                <div key={i}>
                    {!item.disableClick ?
                        <Link
                            data-testid={`breadcrumb-link-${i}`}
                            className={i < path.length - 1
                                ? "text-grey-500 hover:text-portal-blue-primary-shade2 cursor-pointer underline"
                                : "text-portal-blue-primary-shade2 cursor-default font-medium"}
                            to={{
                                pathname: item.value,
                            }}
                            onClick={() => {
                                onClick(item);
                            }}
                        >
                            {item.displayName}
                        </Link>
                        :
                        <label className="text-grey-500 cursor-not-allowed">{item.displayName}</label>}
                    {i < path.length - 1 ?
                        <span className="p-2">/</span>
                        : null}
                </div>
            ))}
        </div>
    )
}

export default Breadcrumb;
